import { create } from "zustand";
import dayjs, { Dayjs } from "dayjs";
import {
  CompanyIdentificationType,
  type CompanyIdentificationValue,
} from "@/types/newLinkBuilder";

export type DataSourceOption = string; // Can be "AlphaScript" or "PropData_AccessGroup_UNN"
export type DataTypeOption = string;
export type DataScaleOption = "Actual" | "Thousands" | "Millions" | "Billions";

interface CashState {
  companyIdentification: CompanyIdentificationValue;
  setCompanyIdentification: (
    value:
      | CompanyIdentificationValue
      | ((prev: CompanyIdentificationValue) => CompanyIdentificationValue)
  ) => void;

  dataSource: DataSourceOption;
  setDataSource: (value: DataSourceOption) => void;

  asOfDate: Dayjs | null;
  setAsOfDate: (value: Dayjs | null) => void;

  dataType: DataTypeOption;
  setDataType: (value: DataTypeOption) => void;

  currency: string;
  setCurrency: (value: string) => void;

  dataScale: DataScaleOption;
  setDataScale: (value: DataScaleOption) => void;

  isScaleUsed: boolean;

  isCurrencyUsed: boolean;

  formula: string;
  setFormula: (value: string) => void;

  formulaLocation: string;
  setFormulaLocation: (value: string) => void;

  reset: () => void;
}

export const useCashStore = create<CashState>((set) => ({
  companyIdentification: {
    selected: CompanyIdentificationType.Search,
    searchInput: "",
    exchange: "",
    ticker: "",
  },
  setCompanyIdentification: (value) =>
    set((state) => ({
      companyIdentification:
        typeof value === "function"
          ? (value as (prev: CompanyIdentificationValue) => CompanyIdentificationValue)(
              state.companyIdentification,
            )
          : value,
    })),

  dataSource: "AlphaScript",
  setDataSource: (value) => set({ dataSource: value }),

  asOfDate: dayjs(),
  setAsOfDate: (value) => set({ asOfDate: value }),

  dataType: "Common Shares_Class A",
  setDataType: (value) =>
    set({
      dataType: value,
      // Show scale only when the selected data type is an Expected Cash Proceeds "Value" node
      isScaleUsed: !!value 
        // &&
        // value.includes("Expected Cash Proceeds") ||
        // value.includes("Value"),
    }),

  dataScale: "Millions",
  setDataScale: (value) => set({ dataScale: value }),
  isScaleUsed: true,

  currency: "USD",
  setCurrency: (value) => set({ currency: value }),
  isCurrencyUsed: true,

  formula: "",
  setFormula: (value) => set({ formula: value }),

  formulaLocation: "",
  setFormulaLocation: (value) => set({ formulaLocation: value }),

  reset: () =>
    set({
      companyIdentification: {
        selected: CompanyIdentificationType.Search,
        searchInput: "",
        exchange: "",
        ticker: "",
      },
      dataSource: "AlphaScript",
      asOfDate: dayjs(),
      dataType: "Common Shares_Class A",
      dataScale: "Millions",
      currency: "USD",
      formula: "",
      formulaLocation: "",
    }),
}));


